<template>
  <div
    :class="[
      'd-flex align-center primary--text text-h5 text-md-h4 text-lg-h3 font-weight-bold',
      className,
    ]"
  >
    <img
      class="d-block mr-3"
      src="../../assets/img/vinheta.png"
      :height="smAndDown ? '40px' : mdOnly ? '50px' : '56px'"
    />

    <slot />
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: "center",
      validator: (val) => ["left", "center", "right"].includes(val),
    },
  },
  computed: {
    className() {
      const classNameAlign = {
        left: "text-left justify-start",
        center: "text-center justify-center",
        right: "text-right justify-end",
      };

      return classNameAlign[this.align] || "";
    },
    mdOnly() {
      return this.$vuetify.breakpoint.mdOnly;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>
